import React, { useState, useCallback } from "react";

const SININ_TURQ = "#25f4df";
const ICONS = { success: "✅", error: "⚠️", info: "ℹ️" };

export function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = "info") => {
    setToast({ message, type, id: Date.now() });
  }, []);

  const closeToast = useCallback(() => setToast(null), []);

  return { toast, showToast, closeToast };
}

export function ToastPopup({ toast, onClose, accentColor, accentText }) {
  if (!toast) return null;
  const accent = accentColor || SININ_TURQ;
  const text   = accentText  || "#042b28";
  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.card} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 30, marginBottom: 10 }}>{ICONS[toast.type] || ICONS.info}</div>
        <div style={{ fontSize: 15, color: "#222", lineHeight: 1.5, whiteSpace: "pre-line" }}>
          {toast.message}
        </div>
        <button onClick={onClose} style={{
          ...styles.btn,
          background: `linear-gradient(145deg, rgba(255,255,255,.55), ${accent} 48%, ${accent})`,
          color: text,
        }}>
          Entendido
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex",
    alignItems: "center", justifyContent: "center", zIndex: 99999, padding: 16 },
  card: { background: "#fff", borderRadius: 16, padding: "26px 24px", width: "100%", maxWidth: 340,
    textAlign: "center", boxShadow: "0 8px 28px rgba(0,0,0,0.3)" },
  btn: {
    border: "1px solid rgba(224,255,252,.9)", borderRadius: 25,
    padding: "10px 20px", marginTop: 18, cursor: "pointer", fontWeight: "900",
    fontSize: 13, textTransform: "uppercase", width: "100%",
    boxShadow: "inset 0 2px 1px rgba(255,255,255,.6), inset 0 -5px 10px rgba(0,0,0,.12), 0 5px 14px rgba(0,0,0,.22)",
  },
};
